export enum FundTypes {
  DAF = 'customer',
  CHARITY = 'vendor',
  PROJECT = 'project',
  PROJECT_CHARITY = 'projectcharity',
}